import { Link } from 'react-router-dom';

/**
 * Shared shell for /login and /register.
 * On-brand background: solid forest-green field + a faint dot texture + two
 * restrained terracotta accent shapes. No external image fetch, no decorative
 * glass blur. Adapts to light/dark via the --app-* theme tokens.
 */
export default function AuthShell({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden" style={{ background: 'var(--app-bg)' }}>
      {/* Subtle dot texture (decorative) */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true"
        style={{
          backgroundImage: 'radial-gradient(var(--app-border-subtle) 1px, transparent 0)',
          backgroundSize: '22px 22px',
          opacity: 0.55,
        }} />
      {/* Restrained terracotta accent shapes (solid, low opacity — no gradient, no blur) */}
      <div className="absolute -top-40 -right-40 w-[28rem] h-[28rem] rounded-full pointer-events-none" aria-hidden="true"
        style={{ background: 'var(--app-accent)', opacity: 0.06 }} />
      <div className="absolute -bottom-44 -left-44 w-[24rem] h-[24rem] rounded-full pointer-events-none" aria-hidden="true"
        style={{ background: 'var(--app-accent)', opacity: 0.04 }} />

      <div className="relative z-10 w-full max-w-md mx-4 animate-fade-in">
        <div className="rounded-2xl p-8 shadow-2xl shadow-black/40" style={{ background: 'var(--app-card)', border: '1px solid var(--app-border)' }}>
          <Link to="/" className="inline-flex items-center gap-1 mb-6 hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="ProPraxis — на главную" className="w-14 h-14 rounded-lg object-cover" />
            <span className="font-heading text-2xl" style={{ color: 'var(--app-text)' }}>
              <span style={{ color: 'var(--app-text-secondary)' }}>Pro</span><span style={{ color: 'var(--app-accent)' }}>Praxis</span>
            </span>
          </Link>
          {children}
        </div>
      </div>
    </div>
  );
}
